import { BOGeneralValues } from "./BOGeneralValues.model";

export class BOInvoiceType extends BOGeneralValues{
    id?:number;
    name?:string;
    code?:string;
}
